import { productIsOwnBrand } from '../../product/productIsOwnBrand'
import { SHOP_APOTHEKE_SELLER_ID } from '../../seller/constants'

import { type RecommendationAttributionProductType } from './recommendationAttributionStorage'

export type RecommendationProductTypeContext = {
  brandName?: string
  sellerId?: string
}

export type RecommendationAttributionContext =
  RecommendationProductTypeContext & {
    productId: string
  }

/**
 * Classifies a recommended product as marketplace, own-brand, or SAE using its seller and brand.
 */
export const recommendationAttributionGetProductType = (
  context: RecommendationProductTypeContext,
): RecommendationAttributionProductType | undefined => {
  const { brandName, sellerId } = context

  if (!sellerId) {
    return undefined
  }

  if (sellerId !== SHOP_APOTHEKE_SELLER_ID) {
    return 'marketplace'
  }

  return brandName && productIsOwnBrand(brandName) ? 'own-brand' : 'sae'
}
